/* typeshyrt — animation system
   content is never gated on JS: the body is visible at first paint,
   this file only adds scroll reveals, stagger, and the exit fade. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ── detect back/forward navigation ─────────────── */
  var isBackNav = document.documentElement.classList.contains('ts-instant');

  /* bfcache restore: page was frozen mid-exit-fade, restore instantly */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      document.documentElement.classList.add('ts-instant');
      document.body.style.transition = 'none';
      document.body.classList.remove('ts-exiting');
      requestAnimationFrame(function () { document.body.style.transition = ''; });
    }
  });

  /* ── share + "shop all" buttons on collection pages (also work inside the feed's collection panel) ── */
  document.addEventListener('click', function (e) {
    var shopAll = e.target.closest && e.target.closest('[data-ts-profile-shop]');
    if (shopAll) {
      var grid = shopAll.closest('.ts-profile') && shopAll.closest('.ts-profile').querySelector('[data-ts-profile-grid]');
      if (grid && grid.scrollIntoView) grid.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
      return;
    }
    var share = e.target.closest && e.target.closest('[data-ts-share-url]');
    if (!share) return;
    var url = share.getAttribute('data-ts-share-url');
    var title = share.getAttribute('data-ts-share-title') || document.title;
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        share.classList.add('is-copied');
        setTimeout(function () { share.classList.remove('is-copied'); }, 1600);
      }, function () {});
    }
  });

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function revealAllInstantly() {
    document.querySelectorAll('.ts-up, .ts-fade').forEach(function (el) {
      el.classList.add('ts-in');
    });
  }

  onReady(function () {
    /* back nav or reduced motion: show immediately, no reveal choreography */
    if (isBackNav || reducedMotion.matches) {
      revealAllInstantly();
      return;
    }

    if (!('IntersectionObserver' in window)) {
      revealAllInstantly();
      return;
    }

    /* ── 1. Scroll-reveal observer ───────────────────── */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ts-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -36px 0px' });

    /* ── 2. Stagger grid children ────────────────────── */
    document.querySelectorAll('.ts-stagger').forEach(function (wrap) {
      Array.from(wrap.children).forEach(function (child, i) {
        if (!child.classList.contains('ts-up')) {
          child.classList.add('ts-up');
        }
        child.style.transitionDelay = (i * 0.06) + 's';
        io.observe(child);
      });
    });

    /* ── 3. Individual .ts-up / .ts-fade elements ────── */
    document.querySelectorAll('.ts-up, .ts-fade').forEach(function (el) {
      // Skip stagger children already observed above
      if (el.closest('.ts-stagger')) return;
      io.observe(el);
    });

    /* ── 4. Section-level reveals ────────────────────── */
    document.querySelectorAll('.ts-section, .ts-pagehead, .ts-product').forEach(function (el) {
      if (!el.classList.contains('ts-up') && !el.classList.contains('ts-fade')) {
        el.classList.add('ts-up');
        io.observe(el);
      }
    });
  });

  /* ── 5. Page exit fade ──────────────────────────── */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;
    /* never hijack modified clicks (new tab / window / download shortcuts) */
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    try {
      var url = new URL(link.href);
      if (url.hostname !== location.hostname) return;        /* external */
      if (url.hash && url.pathname === location.pathname) return; /* same-page anchor */
      if (/^\/(checkout|cart|cdn)/.test(url.pathname)) return;   /* skip Shopify internals */
    } catch (_) { return; }
    if (link.target === '_blank') return;
    if (link.hasAttribute('download')) return;
    if (link.hasAttribute('data-no-transition')) return;
    if (reducedMotion.matches) return; /* navigate natively, no fade */

    e.preventDefault();
    var href = link.href;
    document.body.classList.add('ts-exiting');
    setTimeout(function () { location.href = href; }, 220);
  });

})();
